import { render, staticRenderFns } from "./ComponentDetailPlugin.vue?vue&type=template&id=3c253fac&scoped=true"
import script from "./ComponentDetailPlugin.vue?vue&type=script&lang=js"
export * from "./ComponentDetailPlugin.vue?vue&type=script&lang=js"
import style0 from "./ComponentDetailPlugin.vue?vue&type=style&index=0&id=3c253fac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c253fac",
  null
  
)

export default component.exports